import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Card, Loader} from 'semantic-ui-react';
import moment from 'moment';
import {sumBy} from 'lodash';
import {dateFormatReservation} from '../../../../../common/constants/datesFormat';

class SalesList extends Component {
  renderSales() {
    const {loadingSales, loadingOnOrders, salesList} = this.props;
    if (loadingSales || loadingOnOrders) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    if (!salesList.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={5}>
            No hay datos
          </Table.Cell>
        </Table.Row>
      );
    }
    return salesList.map((element, index) => {
      const dateFormatted = element.date ?
        moment(element.date).format(dateFormatReservation) :
        '';
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.dealerName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.agencyName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.user}</Table.Cell>
          <Table.Cell textAlign='center'>
            {dateFormatted.toUpperCase()}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.quantity}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTotals() {
    const {salesList} = this.props;
    const total = sumBy(salesList, 'quantity') || 0;
    return (
      <Table.Row className='totals-row'>
        <Table.Cell textAlign='left' colSpan={4}>
          TOTAL
        </Table.Cell>
        <Table.Cell textAlign='center'>{total}</Table.Cell>
      </Table.Row>
    );
  }

  render() {
    return (
      <Card fluid raised>
        <div className='title-bar'>
          <div className='title'>
            <h2>Ventas</h2>
          </div>
        </div>
        <Table striped className='scrollable-body'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>
                Concesionario
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Agencia</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Usuario</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Fecha</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.renderSales()}
            {this.renderTotals()}
          </Table.Body>
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingSales': state.partWatching.loadingSales,
    'salesList': state.partWatching.sales,
    'loadingOnOrders': state.partWatching.loadingOnOrders,
  };
};

export default connect(mapStateToProps, {
})(SalesList);
